import { render } from "./SupportComponent.vue?vue&type=template&id=d48428d4&scoped=true"
import script from "./SupportComponent.vue?vue&type=script&lang=js"
export * from "./SupportComponent.vue?vue&type=script&lang=js"

import "./SupportComponent.vue?vue&type=style&index=0&id=d48428d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d48428d4"]])

export default __exports__